import React from 'react';
import { Link } from 'react-router-dom';

const PublicSiteFooter = () => {
  return (
    <footer className="border-t border-ga-border-subtle py-10">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-6 px-4 text-xs text-ga-text-muted md:flex-row md:items-start md:justify-between">
        <div className="space-y-2">
          <p>Ground Aale, a product of SARTECH. 2026.</p>
          <p>
            <a href="mailto:customersupport@groundaale.com" className="hover:text-ga-text-primary">
              customersupport@groundaale.com
            </a>
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-4">
          <Link to="/about" className="hover:text-ga-text-primary">
            About
          </Link>
          <Link to="/contact" className="hover:text-ga-text-primary">
            Contact
          </Link>
          <Link to="/" className="hover:text-ga-text-primary">
            Back to home
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default PublicSiteFooter;
